import React, { useEffect } from "react";
import {
  Row,
  Col,
  Button,
  Table,
} from "antd";

import { withRouter } from "react-router-dom";
import "rxpages/TransactionHistoryRxPage.scss";

import { connect } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import moment from "moment";

import { displayNumberWithComma } from "utils/utils";

import {
  cleanup,
  setCurrency,
  setAllowedCurrencies,
  callGetTransactionHistory,
  callGetTransactionCurrencies,
} from "rx/transactionhistory";

import {
  setModalVisible,
  setFundId,
  setMutualCreditFundId,
  setVirtualAccountName,
  setVirtualAccountNumber,
  setSettlementCurrency,
  setSettlementAmount,
} from "rx/addvasettle";

import CustomRxPageHeader from "rxcomponents/CustomRxPageHeader";
import SelectCurrencyRxComponent from "rxcomponents/common/SelectCurrencyRxComponent";
import VaSettleRxModal from "rxcomponents/modal/VaSettleRxModal";

import { renewAccessToken } from "api/api";

function TransactionHistoryRxPage(props) {
  const intl = useIntl();

  useEffect(() => {
    renewAccessToken();
    props.callGetTransactionCurrencies();

    props.callGetTransactionHistory(props.currency, props.pagination.current);

    // Specify how to clean up after this effect:
    return function cleanup() {
      props.cleanup();
    };
  }, []);

  let transactionHistoryColumns = [
    {
      title: intl.formatMessage({
        id: "app.page.transactionhistoryrxpage.id",
      }),
      width: 60,
      dataIndex: "id",
      key: "id",
    },
    {
      title: intl.formatMessage({
        id: "app.page.transactionhistoryrxpage.datecreated",
      }),
      width: 60,
      dataIndex: "dateCreated",
      key: "dateCreated",
      render: (dateCreated) => `${moment(dateCreated).format("DD/MMM/YYYY")}`,
    },

    {
      title: intl.formatMessage({
        id: "app.page.transactionhistoryrxpage.remarks",
      }),
      width: 140,
      dataIndex: "remarks",
      key: "remarks",
    },
    {
      title: intl.formatMessage({
        id: "app.page.transactionhistoryrxpage.location",
      }),
      width: 60,
      dataIndex: "channelCode",
      key: "channelCode",
      render: (text, record) => {
        let location = "";
        if (record.channelCode == "DBS_HK") {
          location = "HK";
        } else if (record.channelCode == "DBS_SG") {
          location = "SG";
        } else if (record.channelCode == "SAHABAT_SAMPOERNA") {
          location = "ID";
        } else if (record.channelCode == "FLASH_FX") {
          location = "AU";
        }
        return <>{location}</>;
      },
    },
    {
      title: intl.formatMessage({
        id: "app.page.transactionhistoryrxpage.subledgeraccount",
      }),
      width: 60,
      dataIndex: "subledgerAccountReference",
      key: "subledgerAccountReference",
    },
    {
      title: intl.formatMessage({
        id: "app.page.transactionhistoryrxpage.fundid",
      }),
      width: 60,
      dataIndex: "bankTransactionId",
      key: "bankTransactionId",
      render: (text, record) => {
        let fundId = "";
        if (record.mutualCreditBankTransactionId) {
          fundId = record.mutualCreditBankTransactionId;
        } else {
          fundId = record.bankTransactionId;
        }
        return <>{fundId}</>;
      },
    },
    {
      title: intl.formatMessage({
        id: "app.page.transactionhistoryrxpage.currency",
      }),
      width: 60,
      dataIndex: "currency",
      key: "currency",
    },
    {
      title: intl.formatMessage({
        id: "app.page.transactionhistoryrxpage.debit",
      }),
      width: 60,
      dataIndex: "debit",
      key: "debit",
      render: (text, record) => {
        if (record.type === "DEBIT") {
          return <span>{displayNumberWithComma(record.amount, 2)}</span>;
        } else {
          return <span>0.00</span>;
        }
      },
    },
    {
      title: intl.formatMessage({
        id: "app.page.transactionhistoryrxpage.credit",
      }),
      width: 60,
      dataIndex: "credit",
      key: "credit",
      render: (text, record) => {
        if (record.type === "CREDIT") {
          return <span>{displayNumberWithComma(record.amount, 2)}</span>;
        } else {
          return <span>0.00</span>;
        }
      },
    },
    {
      title: intl.formatMessage({
        id: "app.page.transactionhistoryrxpage.claimstatus",
      }),
      width: 60,
      dataIndex: "claimStatus",
      key: "claimStatus",
    },
    {
      title: intl.formatMessage({
        id: "app.page.transactionhistoryrxpage.action",
      }),
      width: 60,
      dataIndex: "action",
      key: "action",
      render: (text, record) => {
        if (record.claimStatus === "UNCLAIMED") {
          return (
            <Button
              type="primary"
              htmlType={"button"}
              style={{ marginLeft: "4px", minHeight: "40px" }}
              onClick={() => {
                props.setModalVisible(true);
                props.setFundId(record.bankTransactionId);
                props.setMutualCreditFundId(record.mutualCreditBankTransactionId);
                props.setVirtualAccountNumber(record.virtualAccountNumber);
                props.setVirtualAccountName(record.virtualAccountName);
                props.setSettlementCurrency(record.currency);
                props.setSettlementAmount(record.amount);
              }}
            >
              {intl.formatMessage({
                id: "app.page.transactionhistoryrxpage.claim",
              })}
            </Button>
          );
        } else {
          return <></>;
        }
      },
    },
  ];

  return (
    <div>
      <CustomRxPageHeader customer={props.customer}
        title={intl.formatMessage({ id: "app.sidebar.transactionhistory" })}
      />

      <div className="bp-page-content bp-page-large">
        {/*
        <h4 className="bp-page-headline">
          <FormattedMessage id="app.page.transactionhistoryrxpage.transactionhistory" />
        </h4>
        */}
        <div
          className="tools-section"
          style={{ marginBottom: "10px", textAlign: "left" }}
        >
          <Row gutter={{ xs: 4, sm: 8 }}>
            <Col md={{ span: 4 }} xs={{ span: 18 }}>
              <SelectCurrencyRxComponent
                placeholder="Select Currency"
                style={{ width: "200px" }}
                currency={props.currency}
                allowedCurrencies={props.allowedCurrencies}
                setCurrency={(value) => props.setCurrency(value)}
              />
            </Col>
            <Col md={{ span: 4 }} xs={{ span: 18 }}>
              <Button
                type="primary"
                htmlType={"button"}
                style={{ marginLeft: "4px", minHeight: "40px" }}
                onClick={() => {
                  props.callGetTransactionHistory(props.currency, 0);
                }}
              >
                <FormattedMessage id="app.page.manageorderpage.search" />
              </Button>
            </Col>
          </Row>

          <Row style={{ marginTop: "20px" }}>
            <Table
              expandIconAsCell={false}
              expandIconColumnIndex={-1}
              className="bp-table"
              columns={transactionHistoryColumns}
              dataSource={props.transactionHistory}
              rowKey="id"
              pagination={props.pagination}
              onChange={(e) => {
                props.callGetTransactionHistory(props.currency, e.current);
              }}
            />
          </Row>
        </div>
      </div>
      <VaSettleRxModal customer={props.customer} />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    currency: state.transactionHistory.currency,
    allowedCurrencies: state.transactionHistory.allowedCurrencies,
    transactionHistory: state.transactionHistory.transactionHistory,
    pagination: state.transactionHistory.pagination,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setModalVisible: (modalVisible) => dispatch(setModalVisible(modalVisible)),
    cleanup: () => dispatch(cleanup()),
    setFundId: (fundId) => dispatch(setFundId(fundId)),
    setMutualCreditFundId: (fundId) => dispatch(setMutualCreditFundId(fundId)),
    setVirtualAccountName: (virtualAccountName) =>
      dispatch(setVirtualAccountName(virtualAccountName)),
    setVirtualAccountNumber: (virtualAccountNumber) =>
      dispatch(setVirtualAccountNumber(virtualAccountNumber)),
    setSettlementCurrency: (settlementCurrency) =>
      dispatch(setSettlementCurrency(settlementCurrency)),
    setSettlementAmount: (settlementAmount) =>
      dispatch(setSettlementAmount(settlementAmount)),
    callGetTransactionHistory: (currency, pageNumber) =>
      dispatch(callGetTransactionHistory(currency, pageNumber)),
    callGetTransactionCurrencies: () =>
      dispatch(callGetTransactionCurrencies()),
    setCurrency: (currency) => dispatch(setCurrency(currency)),
    setAllowedCurrencies: (currencies) =>
      dispatch(setAllowedCurrencies(currencies)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(TransactionHistoryRxPage));
